import { createEventFactory, createName } from '@cp/shared/tracking';

export const FavoriteEvents = {
  Favorite: createEventFactory({
    name: createName('client', 'favorite'),
    goalId: 'nazhatie_knopki_dobavit_v_izbrannoe',
    goalName: 'Нажатие кнопки "Добавить в избранное"',
  }),
};
